import { combineReducers } from "redux";
import { me } from "./authReducer";
import { test as tr } from "./MasterData/testRegistrationReducer";

export default combineReducers({
  me,
  tr
});